/** Planšetės APK (Capacitor) — kiosko prisijungimas. */
export const KIOSK_LOGIN_PATH = '/login/meistrai';

export function isCapacitorNative(): boolean {
  if (typeof window === 'undefined') return false;
  const cap = (window as Window & { Capacitor?: { isNativePlatform?: () => boolean } }).Capacitor;
  return Boolean(cap?.isNativePlatform?.());
}

/** Darbo diena pradėta per planšetės kiosko prisijungimą (ne brigados 4 sk. PIN). */
export function isKioskWorkdayStart(startVia: string | null | undefined): boolean {
  return startVia === 'kiosk-tablet' || startVia === 'kiosk';
}

/**
 * Brigados registracija (4 sk. PIN) nereikalinga planšetėje / kioske —
 * darbo diena jau pradėta per /login/meistrai (6 sk. kodas).
 */
export function shouldHideBrigadeRegistration(opts: {
  isCapacitor?: boolean;
  startVia?: string | null;
}): boolean {
  return Boolean(opts.isCapacitor) || isKioskWorkdayStart(opts.startVia);
}
